import React, { FormEvent, useState } from "react";
import { usePlayerStore } from "@/features/player/lib/usePlayerStore";
import styles from "./RAGQuestion.module.scss";
import { classNames } from "@/shared/lib/classNames/classNames";
import { observer } from "mobx-react-lite";

export const RAGQuestion = observer(() => {
    const { rag, avatar } = usePlayerStore();
    const [question, setQuestion] = useState("Как лечить щитовидную железу");
    const [limit, setLimit] = useState("20");
    const [minRelevance, setMinRelevance] = useState("0.6");
    const [debug, setDebug] = useState(false);

    const handleApiSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const requestBody = {
            question: question,
            limit: parseInt(limit),
            min_relevance: parseFloat(minRelevance),
            debug: debug,
        };
        rag.askRagQuestion(requestBody);
    };

    return (
        <div className={styles.container}>
            <div className={styles.wrapper}>
                <div>
                    <div className={styles.formContainer}>
                        <form onSubmit={handleApiSubmit}>
                            <div className={styles.row}>
                                <label className={styles.label}>Question</label>
                                <textarea
                                    value={question}
                                    onChange={(e) =>
                                        setQuestion(e.target.value)
                                    }
                                    className={styles.question}
                                    required
                                />
                            </div>

                            <div className={styles.row}>
                                <label className={styles.label}>Limit</label>
                                <input
                                    type="number"
                                    value={limit}
                                    onChange={(e) => setLimit(e.target.value)}
                                    min="1"
                                    max="100"
                                    className={styles.number}
                                    required
                                />
                            </div>

                            <div className={styles.row}>
                                <label className={styles.label}>
                                    Min Relevance
                                </label>
                                <input
                                    type="number"
                                    value={minRelevance}
                                    onChange={(e) =>
                                        setMinRelevance(e.target.value)
                                    }
                                    min="0"
                                    max="1"
                                    step="0.1"
                                    className={styles.number}
                                    required
                                />
                            </div>

                            <div className={styles.row}>
                                <label className={styles.label}>
                                    <input
                                        type="checkbox"
                                        checked={debug}
                                        onChange={(e) =>
                                            setDebug(e.target.checked)
                                        }
                                        className={styles.checkbox}
                                    />
                                    Debug Mode
                                </label>
                            </div>

                            <button
                                type="submit"
                                disabled={rag.loading}
                                className={classNames(styles.submit, {
                                    [styles.loading]: rag.loading,
                                })}
                            >
                                {rag.loading
                                    ? "Sending Request..."
                                    : "Send Request"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
});
